import * as Draft from 'draft-js';

import { FormulaFieldEntityDecorator } from './FormulaFieldEntityDecorator';
import { MathOperatorDecorator } from './MathOperatorDecorator';

/**
 * Декораторы в Draft.js — это inline сущности,
 * которые оборачивают подстроку на каком-то отрезке с left по right.
 *
 * Позиции left и right считаются по чистому тексту, без учета html-тегов и пр.
 */
export const ALL_DECORATORS: Draft.DraftDecoratorType =
  new Draft.CompositeDecorator([
    FormulaFieldEntityDecorator,
    MathOperatorDecorator,
  ]);
